import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from "react";
import CourseDetailsArea from '../components/common/curso/curso-detalhes';
import MateriaDetailsArea from '../components/common/materia/materia-details';
import Cta from '../components/common/cta/cta';
import SEO from '../components/seo';
import Footer from '../layout/footers/footer';
import Header from '../layout/headers/header';
import Wrapper from '../layout/wrapper';
import { selectCourses } from '../redux/features/course-slice';
import { handleMaterias, getMateria } from '../api/materia';
import { getCursosByMateria } from '../api/curso';
import { retrieveToken } from './../hooks/use-token';

const DynamicMateriaDetails = () => {

  const { id } = useParams();
  const courses = useSelector(selectCourses);
  const course = courses.find(course => Number(course.id) === Number(id))
  const [materia, setMateria] = useState(null);
  const [materias, setMaterias] = useState([]);
  const [cursos, setCursos] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {

    const tokenApi = retrieveToken();

    if (materia == null) {
      getMateria(tokenApi, Number(id)).then(function(result) {
        setMateria(result);
        if (result.cd_materia) {
          getCursosByMateria(tokenApi, Number(result.cd_materia)).then(function(result) {
            setCursos(result);
          });
        }
      });
    }

    if (materias.length == 0) {
      handleMaterias(tokenApi).then(function(result) {
        setMaterias(result);
      });
    }


});

  return (
    <Wrapper>
      {/* seo start */}
      <SEO pageTitle={'Detalhe Segmento'} />
      {/* seo end */}

      {/* header start */}
      <Header header_shadow={true} />
      {/* header end */}

      {/* materia details */}
      <MateriaDetailsArea cursos={cursos} materias={materias} materia={materia} course={course} />
      {/* materia details */}

      {/* footer start */}
      <Footer />
      {/* footer end */}
    </Wrapper>
  );
};

export default DynamicMateriaDetails;